import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { merge, $ } from "glamor";
import theme from "styles/theme";

const styles = merge(
    {
        borderBottom: `1px solid ${theme.palette.lightGrey}`,
    },
    $(" .listItemText span", {
        paddingLeft: "7px",
        color: theme.palette.textColor,
        fontWeight: "bold",
    })
);

export const Accordion = ({ title, children, dataTestId = "" }) => {
    const [isOpen, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!isOpen);
    };

    return (
        <div {...styles} data-test={dataTestId}>
            <ListItem button onClick={handleClick}>
                {isOpen ? <ExpandLess /> : <ExpandMore />}
                <ListItemText primary={title} className="listItemText" />
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </div>
    );
};
